import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Icon } from '../../../shared/ui';
import { CreatePage } from '../../../features/pages';

import { foldersModel, useFolderPermissions } from '../../../features/folders';

import { useTeamPermissions } from '../../../features/teams';
import { IconMap } from '../../../shared/sprite';

export const EmptyPageFolder: React.FC = () => {
  const currentFolder = useSelector(
    foldersModel.selectors.selectCurrentFolderWithError
  );
  const folderPermissions = useFolderPermissions(currentFolder);

  const { isGuest } = useTeamPermissions();

  const hasCreatePagePermission =
    folderPermissions.isCanCreatePages && !isGuest;

  return (
    <div className="flex items-center justify-center w-full h-full">
      <div className="flex flex-col items-center text-center">
        <div className="flex-shrink-0 mb-4 p-3 rounded-[10px] border border-gray-200 bg-white shadow-xs">
          <Icon
            glyph={IconMap.Files}
            width={24}
            height={24}
            className="text-gray-700"
          />
        </div>
        <h2 className="text-md font-semibold text-gray-900 mb-1">
          No pages found
        </h2>
        {hasCreatePagePermission ? (
          <div className="md:hidden flex flex-col items-center">
            <p className="max-w-80 text-sm text-gray-600 mb-6">
              Start creating your first page by clicking <br />
              the button below.
            </p>
            <CreatePage
              renderButton={(onClick, isLoading) => (
                <Button
                  variant="text"
                  color="primary"
                  size="lg"
                  className="font-semibold shadow-xs !px-4 flex-shrink-0 w-47"
                  onClick={onClick}
                  loading={isLoading}
                >
                  <Icon glyph={IconMap.Plus} width={20} className="mr-1.5" />
                  Create new page
                </Button>
              )}
            />
          </div>
        ) : (
          <p className="max-w-80 text-sm text-gray-600 mb-6">
            Pages will appear here as editors create them in this folder.
          </p>
        )}
      </div>
    </div>
  );
};

export const EmptyAllPages: React.FC = () => {
  const { isGuest } = useTeamPermissions();

  return (
    <div className="flex items-center justify-center w-full h-full">
      <div className="flex flex-col items-center text-center">
        <div className="flex-shrink-0 mb-4 p-3 rounded-[10px] border border-gray-200 bg-white shadow-xs">
          <Icon
            glyph={IconMap.Files}
            width={24}
            height={24}
            className="text-gray-700"
          />
        </div>
        <h2 className="text-md font-semibold text-gray-900 mb-1">
          No pages found
        </h2>
        {!isGuest && (
          <div className="md:hidden flex flex-col items-center">
            <p className="max-w-80 text-sm text-gray-600 mb-6">
              Start creating your first page by clicking <br />
              the button below.
            </p>
            <CreatePage
              renderButton={(onClick, isLoading) => (
                <Button
                  variant="text"
                  color="primary"
                  size="lg"
                  className="font-semibold shadow-xs !px-4 flex-shrink-0 w-47"
                  onClick={onClick}
                  loading={isLoading}
                >
                  <Icon glyph={IconMap.Plus} width={20} className="mr-1.5" />
                  Create new page
                </Button>
              )}
            />
          </div>
        )}
      </div>
    </div>
  );
};
